module.exports = __webpack_public_path__ + "img/print.facb6261.svg";